import Config from '@config';
import { initializeMeteringNodeCommercialApi } from '@gasbi/shared/common/features/meteringNodeCommercial';
import { useSelector } from 'react-redux';

import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringNodeCommercial = initializeMeteringNodeCommercialApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringNodeCommercialApi,
  useGetMeteringNodesCommercialQuery,
  useCreateMeteringNodeCommercialMutation,
  useGetMeteringNodeByIdCommercialQuery,
  useUpdateMeteringNodeCommercialMutation,
  useGetMeteringNodesCommercialInfiniteQuery,
} = meteringNodeCommercial;

const getCachedNodeByIdSelector = cachedItemByIdSelector(
  'meteringNodeCommercialApi',
  'getMeteringNodesCommercialI',
);

export const useGetCachedNodeCommercialByIdSelector = id =>
  useSelector(getCachedNodeByIdSelector(id));
